import store from '../../store';
import DeviceStorage from './../../components/DeviceStorage/DeviceStorage';
import { pushSession } from './../../requests/loader';
import { showModal, MODAL_REINTENTO } from '../../actions/modal';
import { playFullMedia } from '../../actions/playmedia';

class UtilsIsSticky {

    isStickyLogout() {

        const ui = DeviceStorage.getItem('__UUID__');
        const hadLoginSuccess = DeviceStorage.getItem('hadLoginSuccess');
        store.dispatch(playFullMedia({ src: null, event: null }));
        DeviceStorage.clear();
        DeviceStorage.setItem('__UUID__', ui);
        DeviceStorage.setItem('IsLogOut', true);
        if (hadLoginSuccess === '1') DeviceStorage.setItem('hadLoginSuccess', '1');
        window.location.href = '/';

        // Youbora
        if (window.youboraTrackingPlugin) {
            if (window.youboraTrackingPlugin.storage) {
                if (window.youboraTrackingPlugin.storage.removeLocal
                    && typeof window.youboraTrackingPlugin.storage.removeLocal === "function") {
                    window.youboraTrackingPlugin.storage.removeLocal('data');
                }
                if (window.youboraTrackingPlugin.storage.removeSession
                    && typeof window.youboraTrackingPlugin.storage.removeSession === "function") {
                    window.youboraTrackingPlugin.storage.removeSession('data');
                }
            }
            if (window.youboraTrackingPlugin.restartViewTransform
                && typeof window.youboraTrackingPlugin.restartViewTransform === "function") {
                window.youboraTrackingPlugin.restartViewTransform();
            }
            if (window.youboraTrackingPlugin.setOptions
                && typeof window.youboraTrackingPlugin.setOptions === "function") {
                window.youboraTrackingPlugin.setOptions();
            }
        }
        if (window.youboraAnalyticsPlugin
            && window.youboraAnalyticsPlugin.infinity
            && typeof window.youboraAnalyticsPlugin.infinity.fireSessionStop === "function") {
            window.youboraAnalyticsPlugin.infinity.fireSessionStop();
        }
    }


    getPushSession = async ( callback, extra_argv, extra_argv_fnsuccess) => {
        const user = store.getState().user;
        const isIptv = user.isIptv || false;
        if(!isIptv){

          if (user && user.user_id) {
              await pushSession(user.user_id)
                  .then(result => {
                      if(callback) {
                          callback(result, extra_argv);
                      }
                      return result;
                  })
                  .catch(err => {
                      store.dispatch(
                          showModal({
                              modalType: MODAL_REINTENTO,
                              modalProps: {
                                  onReject: utilsIsSticky.isStickyLogout,
                                  onRetry: this.getPushSession,
                                  messageModal: null
                              }
                          })
                      );
                  });
          } else {
            //FIx para cuando authdevice contesta con error, entrar de forma anonima
            if (callback && typeof callback === "function") {
              callback(null, extra_argv, extra_argv_fnsuccess)
            }
          }
        }
    };

    getPushSessionRegister = async (response) => {
        const {user_id = false, user_session = false} = response;
        if (user_id) {
          await pushSession(user_id, user_session)
                .then(result => {
                    return result;
                })
                .catch(err => {
                    store.dispatch(
                        showModal({
                            modalType: MODAL_REINTENTO,
                            modalProps: {
                                onReject: utilsIsSticky.isStickyLogout,
                                onRetry: this.getPushSession,
                                messageModal: null
                            }
                        })
                    );
                });
        }
    }

}
const utilsIsSticky = new UtilsIsSticky();

export default utilsIsSticky;



// WEBPACK FOOTER //
// ./src/utils/user/IsSticky.js